import { systemTimeZone } from "@app/core";
import { useI18n } from "../../lib/useI18n.js";

/** Full IANA list when the runtime supports it (modern V8 / Tauri WebViews do);
 *  fall back to the device zone alone otherwise. */
function zoneList(): string[] {
  const sv = (Intl as unknown as { supportedValuesOf?: (k: string) => string[] }).supportedValuesOf;
  const all = typeof sv === "function" ? sv("timeZone") : [systemTimeZone()];
  return all;
}

/**
 * Time-zone picker. `null` = floating / device-local (legacy behaviour). When a
 * zone is set, the task's wall-clock is anchored to it, so recurring events stay
 * at a stable local time across DST.
 */
export function TimeZoneField({ value, onChange }: { value: string | null; onChange: (tz: string | null) => void }) {
  const { t } = useI18n();
  return (
    <div className="flex flex-col gap-1">
      <p className="text-xs text-muted-foreground">{t("taskForm.timeZone")}</p>
      <select
        className="rounded-md border border-input bg-background px-2 py-1.5 text-sm"
        value={value ?? ""}
        onChange={(e) => onChange(e.target.value === "" ? null : e.target.value)}
      >
        <option value="">{t("taskForm.deviceLocal")}</option>
        {zoneList().map((z) => (
          <option key={z} value={z}>{z.replace(/_/g, " ")}</option>
        ))}
      </select>
    </div>
  );
}
